<script lang="ts">
    import {hoursOptions} from "../utils";
    import {createEventDispatcher} from "svelte";

    import NauiSlideOver from "../naui/layout/NauiSlideOver.svelte";
    import NauiButton from "../naui/atoms/NauiButton.svelte";
    import NauiDatePicker from "../naui/atoms/NauiDatePicker.svelte";

    import NauiSelect from "../naui/atoms/NauiSelect.svelte";
    import NauiInput from "../naui/atoms/NauiInput.svelte";
    import NauiTextarea from "../naui/atoms/NauiTextarea.svelte";

    export let open;
    export let currentDay;
    export let calendarType;
    export let idService;

    export let program;
    export let serviceProgramming;

    export let numDays;
    export let eventTags;

    export let backButton = true;

    let horas = hoursOptions;
    let dispatch = createEventDispatcher();

    function addAdditional() {
        const dt = new Date(serviceProgramming.date);

        dt.setUTCDate(dt.getUTCDate() + serviceProgramming.additional.length + 1);

        const mthNum = dt.getUTCMonth() + 1;
        const mth = mthNum < 10 ? `0${mthNum}` : mthNum;
        const newDt = `${dt.getUTCFullYear()}-${mth}-${dt.getUTCDate()}`;

        serviceProgramming.additional.push({
            date: newDt,
            time: serviceProgramming.time
        });
        serviceProgramming = serviceProgramming;
    }

    function updateDays(newDays) {
        if (isNaN(newDays)) {
            return;
        }
        numDays = newDays;

        if (numDays < serviceProgramming.additional.length) {
            serviceProgramming.additional = serviceProgramming.additional.slice(0, numDays)
        } else {
            while (numDays > serviceProgramming.additional.length) {
                addAdditional();
            }
        }
    }

    function deleteAdditional(index) {
        serviceProgramming.additional.splice(index, 1);
        serviceProgramming = serviceProgramming;
    }

    function getTag(slug) {
        return eventTags.filter((x) => x.slug === slug)[0];
    }
</script>

<NauiSlideOver bind:open={open} title="{program ? 'Programar servicio' : currentDay.title}">
    {#if idService && !program}
        <div class="mb-15">
            <NauiButton caption="PROGRAMAR {calendarType.toUpperCase()}" mode="stroked" iconFamily="fas" color="accent"
                        icon="plus" on:click={() => {program = !program}}/>
        </div>
    {/if}
    {#if program}
        {#if backButton}
        <div class="w-100 box-l sx-1">
            <div on:click={() => {program = !program}} class="mr-1">
                <i class="fal fa-long-arrow-left accent"></i>
            </div>
            { calendarType } - Solicitud #{idService}
        </div>
        {/if}
        <div class="my-15">
            <div class="grid-1 gap-0 my-1">
                <NauiDatePicker label="Fecha estimada" bind:value={serviceProgramming.date}/>
            </div>
            <NauiSelect label="Hora de {calendarType}" options="{horas}" icon="clock"
                        bind:value={serviceProgramming.time}/>
            {#if calendarType === 'Servicio'}
                <div class="box sx-1 mt-1">
                    <NauiButton icon="minus-circle" iconFamily="fal" color="accent"
                                on:click={() => {updateDays(Math.max(0, numDays - 1))}}/>
                    <NauiInput value={numDays} label="Cantidad de días" type="number"
                               on:input={(ev) => {updateDays(ev.target.value)}}/>
                    <NauiButton icon="plus-circle" iconFamily="fal" color="accent"
                                on:click={() => {updateDays(numDays + 1)}}/>
                </div>
            {/if}
            {#each serviceProgramming.additional as additional, i}
                <hr>
                <div class="day-grid gap-ii mt-1">
                    <div class="sy-1">
                        <NauiDatePicker label="Fecha día {i + 1}" bind:value={additional.date}/>
                        <NauiSelect label="Hora día {i + 1}" options="{horas}" icon="clock"
                                    bind:value={additional.time}/>
                    </div>
                    <div class="pt-iii">
                        <NauiButton iconFamily="fas" color="primary" icon="trash"
                                    on:click={() => {deleteAdditional(i)}}/>
                    </div>
                </div>
            {/each}
            {#if calendarType === "Visita"}
                <NauiTextarea label="Observaciones visita" bind:value={serviceProgramming.observations}/>
            {/if}
        </div>
        {#if calendarType === 'Servicio'}
            <div>
                <NauiButton caption="AÑADIR DÍA" iconFamily="fas" color="secondary" icon="plus"
                            on:click={addAdditional}/>
            </div>
        {/if}
        <hr>
        <div class="w-100 box-c">
            <NauiButton caption="GUARDAR" size="large" iconFamily="fal" color="accent" icon="calendar"
                        on:click={() => {dispatch('program', serviceProgramming)}}/>
        </div>
    {:else}
        {#each currentDay.services as event}
            <table class="naui-table w-100 mb-15">
                <tr style="background: {getTag(event.tag).background}; color: {getTag(event.tag).color}">
                    <td>
                        <div>
                            <p style="color: {getTag(event.tag).color}; font-weight: 600">{event.status}</p>
                        </div>
                    </td>
                    <td>
                        <div class="box-r">
                            <NauiButton href={event.route} caption="DETALLES" mode="stroked" color="accent"
                                        size="small"/>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>
                        <div>Vendedor</div>
                    </td>
                    <td>
                        <div>{event.vendedor}</div>
                    </td>
                </tr>
                <tr>
                    <td>
                        <div>Cliente</div>
                    </td>
                    <td>
                        <div>{event.cliente}</div>
                    </td>
                </tr>
                <tr>
                    <td>
                        <div>Hora</div>
                    </td>
                    <td>
                        <div>{event.hour}</div>
                    </td>
                </tr>
            </table>
        {/each}
    {/if}
</NauiSlideOver>
<style>
    .day-grid {
        display: grid;
        grid-template-columns: 1fr 45px;
    }
</style>
